import { Brand } from 'components/ui';
import { LegalLinks } from 'components/LegalLinks';
import env from 'config/env';
import { usePhoneLogin, LOGIN_STEPS } from '../hooks/usePhoneLogin';
import { PhoneStep } from '../components/PhoneStep';
import { OtpStep } from '../components/OtpStep';

/**
 * Login screen. Renders the phone or OTP step based on `step`.
 * On successful verification the auth state updates and the route guard
 * (PublicRoute) redirects to the dashboard automatically.
 */
export function LoginPage() {
  const {
    step,
    phone,
    devOtp,
    error,
    isSendingOtp,
    isVerifying,
    requestOtp,
    verifyOtp,
    resendOtp,
    reset,
  } = usePhoneLogin();

  return (
    <div className="flex min-h-full items-center justify-center bg-gradient-to-b from-surface-100 to-surface-200 px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <Brand size="lg" className="mb-4 shadow-card" />
          <h1 className="text-2xl font-semibold text-slate-900">Quro Vendor</h1>
          <p className="mt-1 text-sm text-slate-500">
            Sign in to manage your catalog and orders.
          </p>
        </div>

        <div className="panel p-6 sm:p-8">
          {step === LOGIN_STEPS.PHONE ? (
            <PhoneStep
              onSubmit={requestOtp}
              isSubmitting={isSendingOtp}
              error={error}
              initialPhone={phone}
            />
          ) : (
            <OtpStep
              phone={phone}
              onSubmit={verifyOtp}
              onResend={resendOtp}
              onBack={reset}
              isSubmitting={isVerifying}
              isResending={isSendingOtp}
              error={error}
              devOtp={devOtp}
            />
          )}
        </div>

        <div className="mt-6 space-y-2 text-center">
          <p className="text-xs text-slate-400">
            By continuing you agree to Quro&apos;s{' '}
            {env.legal.vendorTerms ? (
              <a
                href={env.legal.vendorTerms}
                target="_blank"
                rel="noreferrer"
                className="text-slate-500 underline underline-offset-2 hover:text-slate-700"
              >
                Vendor Terms of Service
              </a>
            ) : (
              'Vendor Terms of Service'
            )}
            .
          </p>
          <LegalLinks />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
